import { GetStreamUserEntity } from "@modules/chat/entities/getStreamUserEntity"
import { XIcon } from "lucide-react"
import { Avatar } from "stream-chat-react"
import styled from "styled-components"
import { Text } from "@/components/ui/baseUi/text"

type UserGridItemProps = {
  user: GetStreamUserEntity
  removeButton?: boolean
  onRemoveUser: () => void
}

export const UserGridItem: React.FC<UserGridItemProps> = ({ user, removeButton = false, onRemoveUser }) => {
  return (
    <div className="mx-5 flex max-w-40 flex-col items-center">
      <div className="relative">
        <Avatar image={user.avatar?.url} name={user.username} className="size-4" />
        {removeButton && (
          <CloseIcon onClick={onRemoveUser}>
            <XIcon className="size-3.5" />
          </CloseIcon>
        )}
      </div>
      <Text fontStyle="BS" className="mt-1 line-clamp-2 text-center">
        {user.username}
      </Text>
    </div>
  )
}

const CloseIcon = styled.div`
  position: absolute;
  top: -7px;
  right: -7px;
  background-color: var(--color-red-500);
  width: 20px;
  height: 20px;
  color: var(--color-white);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`
